import { toGet } from '@/models/account'

export default axios => ({
  getAccess: ({ type, project, withRoles, withRolesDescription, withPermissionsSlugIndex, withPermissionsSlugNewIndex }) => axios.get('account/access', {
    params: toGet({ type, project, withRoles, withRolesDescription, withPermissionsSlugIndex, withPermissionsSlugNewIndex }) 
  })
})
